
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solar-generators",
      function () {
        return require("private-next-pages/solar-generators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solar-generators"])
      });
    }
  